export const productionHandoverStatusLabels = {
  AVAILABLE: 'Dostępne',
  REQUESTED: 'Oczekuje na analizę',
  PROCESSING: 'Analiza w toku',
  DATA_COLLECTED: 'Oczekuje na finalizację',
  COMPLETED: 'Zgodne',
  DISCREPANCY: 'Niezgodność',
  FAILED: 'Błąd',
};

export const productionHandoverIssueLabels = {
  SAP_CONFIRMATION_MISSING: 'Brak potwierdzenia SAP',

  NO_EWM_TASK: 'Brak zadania w EWM',

  EWM_IN_PROCESS: 'HU w trakcie realizacji',

  EWM_OPEN: 'Otwarte zadanie EWM',

  EWM_CANCELLED: 'Anulowane zadanie EWM',

  QUANTITY_MISMATCH: 'Różnica ilości',

  EXTRA_EWM_HU: 'Dodatkowe HU w EWM',

  UNKNOWN: 'Nieznany problem',
};
